import './style.css'

export default class AboutPage {
    static selector = '.about-page'

    constructor(block) {
        this.block = block;
    }
}
